import { yupResolver } from '@hookform/resolvers/yup'
import React, { useContext, useEffect, useState } from 'react'
import { Controller, useFieldArray, useForm } from 'react-hook-form'
import { addiCalSchema } from '../../../util/validationSchema'
import { useDispatch, useSelector } from 'react-redux'
import { SpinnerContext } from '../../../context/spinnerContext'
import { addiCal, getTooltipIcal } from '../../../redux/slices/propertySlice'
import DeleteIcon from '../../../assets/img/svg/delete-icon.svg'
import AddIcon from '../../../assets/img/svg/add-icon.svg'
import InfoIcon from '../../../assets/img/svg/info-icon.svg'
import { errorToast, successToast } from '../../../util/Toast/toast'
import { Button, OverlayTrigger, Popover } from 'react-bootstrap'
import DeletePopup from '../../../component/deletePopup'
import { ICAL_MSG } from '../../../util/constant'

const AddEditiCal = ({ propertyId, setIsRefresh, toggleiCalModal, disable }) => {
  const dispatch = useDispatch()
  const { changeLoader } = useContext(SpinnerContext)
  // State to track the currently open popover
  const [activePopover, setActivePopover] = useState(null)

  // Function to toggle a specific popover
  const togglePopover = (id) => {
    setActivePopover((prev) => (prev === id ? null : id))
  }
  const { iCalData } = useSelector(({ property }) => property)
  const [currentIndex, setCurrentIndex] = useState(0)
  const [deleteId, setDeleteId] = useState(null)
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)

  const openDeleteModal = (_id) => {
    setDeleteId(_id)
    setIsDeleteModalOpen(!isDeleteModalOpen)
  }

  const onHandleDelete = () => {
    if (deleteId !== null) {
      remove(deleteId)
    }
    openDeleteModal(null)
  }

  const currentTooltip = iCalData?.length && iCalData[currentIndex]

  const handleNext = () => {
    if (currentTooltip.has_next) {
      setCurrentIndex((prevIndex) => prevIndex + 1)
    }
  }

  const handlePrevious = () => {
    if (currentTooltip.has_previous) {
      setCurrentIndex((prevIndex) => prevIndex - 1)
    }
  }

  const popoverClick = (
    <Popover id="popover-trigger-click" title="Popover bottom">
      <div className="popover-content-custom p-3">
        <strong className="popover-title">{currentTooltip?.category}</strong>
        <p className="popover-description">{currentTooltip?.tool_tip}</p>
        <div className="popover-buttons">
          {currentTooltip?.has_previous && (
            <Button className="popover-btn previous" variant="secondary" size="sm" onClick={handlePrevious} disabled={!currentTooltip?.has_previous}>
              Previous
            </Button>
          )}
          {currentTooltip?.has_next && (
            <Button
              className="popover-btn next justify-content-end"
              variant="secondary"
              size="sm"
              onClick={handleNext}
              disabled={!currentTooltip?.has_next}
            >
              Next
            </Button>
          )}
        </div>
      </div>
    </Popover>
  )

  const { handleSubmit, control, trigger, watch } = useForm({
    resolver: yupResolver(addiCalSchema),

    defaultValues: {
      propertyICalLink: [
        {
          ical_label: '',
          ical_link: ''
        }
      ]
      // cleaning_on: 'Cleaning on checkout'
    }
  })

  const { fields, remove, append } = useFieldArray({
    control,
    name: 'propertyICalLink'
  })

  // eslint-disable-next-line no-unused-vars
  const selectedValue = watch('cleaning_on')

  const onSubmit = (data) => {
    setIsRefresh(false)
    changeLoader(true)
    if (propertyId) {
      const payload = {
        ...data,
        property_id: propertyId
      }
      dispatch(addiCal(payload)).then(({ payload, error }) => {
        if (payload?.status === 200) {
          toggleiCalModal()
          setIsRefresh(true)
          changeLoader(false)
          successToast(payload?.data?.status_message || 'Success!')
        } else {
          errorToast(payload?.data?.status_message || error?.message)
          changeLoader(false)
        }
      })
    }
  }

  useEffect(() => {
    dispatch(getTooltipIcal())
      .then(() => {})
      .catch((err) => {
        console.log('err :>> ', err)
      })
  }, [])

  return (
    <div className="container-fluid">
      <form onSubmit={handleSubmit(onSubmit)}>
        {/* <div className="row"> */}
        {fields.map((field, index) => (
          <div key={field.id} className="row">
            {fields.length - 1 === index && (
              <div className="col-md-12">
                <div className="input_icon_box icon_filed_div">
                  <div className="form-group mb-0 w-100">
                    <Controller
                      name={`propertyICalLink.${index}.ical_label`}
                      control={control}
                      defaultValue={field.ical_label}
                      render={({ field: { value, onChange }, fieldState }) => (
                        <>
                          <input
                            className="form-control"
                            type="text"
                            placeholder="ICal Name"
                            value={value}
                            disabled={disable}
                            onChange={(val) => {
                              onChange(val)
                              trigger(`propertyICalLink.${index}.ical_label`)
                            }}
                          />
                          <small>{fieldState?.error?.message}</small>
                        </>
                      )}
                    />
                  </div>
                </div>
              </div>
            )}
            <div className={fields.length - 1 === index ? 'col-md-12' : 'col-md-12'}>
              <div className="input_icon_box icon_filed_div">
                <div className="form-group mb-0 w-100 input_with_icon position-relative">
                  <Controller
                    name={`propertyICalLink.${index}.ical_link`}
                    control={control}
                    defaultValue={field.ical_link}
                    render={({ field: { value, onChange }, fieldState }) => (
                      <>
                        <input
                          className="form-control"
                          type="text"
                          placeholder="ICal Link"
                          value={value}
                          disabled={disable || fields.length - 1 !== index}
                          onChange={(val) => {
                            onChange(val)
                            trigger(`propertyICalLink.${index}.ical_link`)
                          }}
                        />

                        <OverlayTrigger
                          trigger="click"
                          placement="top"
                          overlay={popoverClick}
                          rootClose // Ensures the popover closes when clicking outside
                          show={activePopover === index}
                        >
                          <span className="info_box_div" onClick={() => togglePopover(index)}>
                            <img src={InfoIcon} alt="Info" width={20} />
                          </span>
                        </OverlayTrigger>

                        <small>{fieldState?.error?.message}</small>
                      </>
                    )}
                  />
                </div>

                {!disable && (
                  <>
                    {fields.length - 1 === index ? (
                      <div
                        className="icon_box_div add_icon"
                        onClick={() => {
                          let lastVal = watch(`propertyICalLink`)?.[index]
                          trigger('propertyICalLink')
                          if (lastVal?.ical_label && lastVal?.ical_link) {
                            append({ ical_label: '', ical_link: '' })
                            setActivePopover(null) // Close the popover
                          }
                        }}
                      >
                        <img src={AddIcon} alt="upload" width={24} />
                      </div>
                    ) : (
                      <div
                        className="icon_box_div delete_icon"
                        onClick={() => {
                          openDeleteModal(index)
                        }}
                      >
                        <img src={DeleteIcon} alt="upload" width={17} />
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
            {disable && (
              <div className="col-md-11 fs-16 fw-400 red_color mb-3" style={{ color: 'red' }}>
                {ICAL_MSG}
              </div>
            )}
          </div>
        ))}

        <div className="row mb-3">
          <div className="multi_btn_div">
            <button type="button" className="btn common-outline-btn w-100" onClick={() => toggleiCalModal()}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary common-field-btn w-100" disabled={disable}>
              {`Save`}
            </button>
          </div>
        </div>
      </form>
      {isDeleteModalOpen && (
        <DeletePopup isDeleteModalOpen={isDeleteModalOpen} toggle={() => openDeleteModal(null)}>
          <div className="multi_btn_div">
            <button type="button" className="btn common-outline-btn w-100" onClick={() => setIsDeleteModalOpen(false)}>
              Cancel
            </button>
            <button type="button" className="btn btn-danger common-field-btn w-100" onClick={() => onHandleDelete()}>
              Delete
            </button>
          </div>
        </DeletePopup>
      )}
    </div>
  )
}

export default AddEditiCal
